import React, { useState, useEffect } from 'react';
import RadioButton from '../../../../components/Dashboard-res/CommonComponent/RadioButton';
import { Formik, Form, useFormikContext } from 'formik';
import {
  GetKhataList,
  savePropertyTilte
} from '../../../../common/constants/api';
import styles from './PropertyKhata.module.css';
import CommonKhataDesk from './CommonKhataDesk';
import PopUp from '../../../../common/components/PopUp/PopUp';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';

function PropertyKhata() {
  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue
  } = useFormikContext();

  const [initState, setInitState] = useState({
    isFetching: false,
    isFetched: false,
    isFailure: false
  });

  const [showRadioAndBg, setShowRadioAndBg] = useState('');
  const [khata, setKhata] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [LoadingFail, setLoadingFail] = useState(false);

  function onClickCards(selectedPropertyTypeID) {
    setFieldValue('propertyTitleId', selectedPropertyTypeID);
    setShowRadioAndBg(selectedPropertyTypeID);
  }
  const [savedKhata, setSavedKhata] = useState(values.savedKhataId());
  useEffect(() => {
    if (savedKhata) {
      setFieldValue('propertyTitleId', savedKhata.toString());
      setShowRadioAndBg(savedKhata.toString());
    }
  }, []);

  function getLoadingMsg() {
    if (typeof LoadingFail !== 'boolean') {
      if (LoadingFail) return LoadingFail?.message;
    }
    return <p>Loading ...</p>;
  }
  const submitPropertyKhata = () => {
    setLoadingFail(false);
    setLoading(true);
    if (!khata?.length) {
      handleSubmit();
      return;
    }
    savePropertyTilte(
      getApplicantionInfo().leadId,
      values.propertyTitleId
    ).then(response => {
      if (response.isAxiosError) {
        setLoading(true);
        setLoadingFail({
          message: response.error.data.message || 'Something went wrong !',
          status: response.error.status
        });
      } else {
        setLoading(false);
        handleSubmit();
      }
    });
  };

  useEffect(() => {
    setLoading(true);
    if (!values.pinCode()) {
      handleSubmit();
    } else {
      setInitState({
        ...initState,
        isFetching: true
      });
      GetKhataList(values.pinCode())
        .then(res => {
          setLoading(false);
          setKhata(res);
          setInitState({
            ...initState,
            isFetching: false,
            isFetched: true
          });
        })
        .catch(err => {
          setLoadingFail(true);
          setLoading(true);
          setInitState({
            ...initState,
            isFetching: false,
            isFetched: true,
            isFailure: true
          });
        });
    }
  }, []);
  const { isFetching, isFetched, isFailure } = initState;
  return (
    <React.Fragment>
      <div>
        <div>
          <div className="pt-5 pl-2 pb-4 md:pb-0 md:pl-0 text-base text-black-400 font-Roboto font-medium">
            Property Title ?
          </div>

          {!isFetching && (
            <>
              <div className="flex flex-wrap mt-6  hidden md:flex">
                {khata &&
                  khata.map(each => {
                    return (
                      <CommonKhataDesk
                        id={each?.id?.toString()}
                        key={each?.id}
                        label={each?.propertyTitle}
                        onClickCards={onClickCards}
                        showRadioAndBg={showRadioAndBg}
                      >
                        <RadioButton
                          name="propertyTitleId"
                          value={each?.id?.toString()}
                          checked={
                            values.propertyTitleId === each?.id?.toString()
                          }
                          onChange={e => {
                            handleChange(e);
                          }}
                          onBlur={e => {
                            handleBlur(e);
                          }}
                        />
                      </CommonKhataDesk>
                    );
                  })}
              </div>
              <div className="block md:hidden max-w-lg pr-5">
                {/* ////for mobile */}

                {khata &&
                  khata.map((each, index) => {
                    return (
                      <div
                        key={each?.id}
                        className="flex  items-center justify-between"
                      >
                        <label
                          htmlFor=""
                          className="text-black-500 font-normal text-sm m-2"
                        >
                          {each?.propertyTitle}
                        </label>
                        <RadioButton
                          name="propertyTitleId"
                          value={each?.id?.toString()}
                          checked={
                            values.propertyTitleId === each?.id?.toString()
                          }
                          onChange={e => {
                            handleChange(e);
                          }}
                          onBlur={e => {
                            handleBlur(e);
                          }}
                        />
                      </div>
                    );
                  })}
              </div>
            </>
          )}
          {Loading ? (
            <PopUp
              goto={LoadingFail.status == 403}
              dontClose={LoadingFail?.status == 403}
              type={LoadingFail?.message ? 'fail' : 'loading'}
              text={getLoadingMsg()}
              show={Loading}
              setShow={setLoading}
            />
          ) : null}
          {((isFailure && isFetched) || khata.length === 0) && (
            <div className="text-center p-4">No Available Khata Types.</div>
          )}
          <button
            onClick={submitPropertyKhata}
            className="submitButton w-56  font-semibold"
            type="button"
            disabled={isSubmitting}
          >
            NEXT
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
export default PropertyKhata;
